<template>
    <div class="page-container has-action">
        <van-nav-bar left-arrow title="选择收货地址" @click-left="$router.replace({name:'shop-product-buy',query:{addressId:value}})"></van-nav-bar>
        <div class="px-20 page ">
            <div v-for="(n,i) of list" class="flex-row pt-20 cell-address" :key="`address-${i}`" @click="$router.replace({name:'shop-product-buy',query:{addressId:n.id}})">
                <div v-if="n.id == $route.query.choose " class="mr-10">
                    <van-icon name="checked" class="color-red fs-16"/>
                </div>
                <div class="content" :name="n.id" >
                    <div class=" fs-16">{{n.receiveName}} <span class="fs-14 ml-10 color-gray-dark">{{n.phone}}</span></div>
                    <div class="fs-12"><van-tag v-if="n.isDefault" class="mr-10" >默认</van-tag>{{`${n.provinceName} ${n.areaName} ${n.cityName} ${n.address}`}}</div>
                </div>
                <div class="right">
                    <van-button @click.stop="$router.push({name:'address-edit',params:{id:n.id}, query:{'redirect':'address-choose'}})" >编辑</van-button>
                </div>
            </div>
        </div>
        <div class="page-action px-20">
            <van-button :to="{name:'address-edit', query:{'redirect':'address-choose'}}" type="danger" round size="large">添加新地址</van-button>
        </div>
    </div>
</template>

<script>
    import * as GoodsApi from "@/api/goods";

    import { Tag, Icon } from "vant";
    export default {
        name: "index",
        data:()=>({
            value:'',
            list:[]
        }),
        beforeMount() {
            GoodsApi.placeList().then(data=>{
                this.list = data;
                if(this.$route.query.choose) {
                    this.value = this.$route.query.choose;
                } else if(this.list.length > 0) {
                    let address =  this.list.find(n=>n.isDefault);
                    if(!address) {
                        address = this.list[0]
                    }
                    this.value = address.id;
                }
            }).catch(e=>{

            });
        },
        methods:{
        },
        components: {
            [Tag.name]: Tag,
            [Icon.name]: Icon,
        },
    }
</script>

<style lang="less" scoped>
    .page-container {
        padding-top: 0;
    }
    .cell-address {
        align-items: center;
        .left-icon {
            width: 45px;
            height: 45px;
            text-align: center;
            line-height: 45px;
            border-radius: 50%;
            background: @gray-dark;
            color: #fff;
            font-size: 20px;
        }
        .content {
            flex: 1;
        }
        .van-tag {
            background: #f5dddb;
            color: #cb574d;
        }
        .van-cell__value {

         }
        .right {
            button {
                color: @red;
                margin: 0;
                border: none;
                background: transparent;
            }
        }
        ::v-deep .van-radio__icon--checked .van-icon {
            border-color: @red;
            background-color: @red;
        }
    }
</style>